import { menuIcons } from '../../components/atoms/Icon/Base64Icon/menuIcons';

/**
 * [ホーム画面] メニュー項目の定義
 * GlobalNavigationの順序と同じ
 */
export type NavigationItem = {
  name: keyof typeof menuIcons;
  href: string;
  hasFavorite: boolean;
  decorationIcon?: {
    type?: 'new' | 'update';
    prdReleaseDate: string;
  };
};

/**
 * メニュー項目の順序定義
 * この配列を単一の情報源となり、
 * GlobalNavigation.tsxでも使用される
 */
export const navigationItems: NavigationItem[] = [
  {
    name: 'ホーム',
    href: '/',
    hasFavorite: false,
    decorationIcon: { prdReleaseDate: '2024-10-09' },
  },
  {
    name: 'チェーン店レポート',
    href: '/report/chain',
    hasFavorite: true,
    decorationIcon: { type: 'update', prdReleaseDate: '2026-08-26' }, // 推移グラフ複数並列表示
  },
  {
    name: '店舗レポート',
    href: '/report/hall',
    hasFavorite: true,
    decorationIcon: { type: 'update', prdReleaseDate: '2026-08-26' }, // 推移グラフ複数並列表示
  },
  {
    name: '予定進捗推移',
    href: '/report/planProgressTransition',
    hasFavorite: true,
    decorationIcon: { prdReleaseDate: '2025-09-24' }, // 着地見込みデータの表示
  },
  {
    name: 'PPMシェア一覧',
    href: '/report/ppmShare',
    hasFavorite: true,
    decorationIcon: { prdReleaseDate: '2024-08-21' }, // 検索結果共有機能追加
  },
  {
    name: '機種別償却',
    href: '/report/depreciation',
    hasFavorite: false,
    decorationIcon: { type: 'update', prdReleaseDate: '2026-09-30' }, // SIS貢献週・SIS累計台粗利の追加
  },
  {
    name: '機種集計',
    href: '/report/model',
    hasFavorite: true,
    decorationIcon: { type: 'update', prdReleaseDate: '2026-10-28' }, // 拾球率・役物率の追加
  },
  {
    name: '機種別商圏データ',
    href: '/report/kiSyoken',
    hasFavorite: true,
    decorationIcon: { type: 'update', prdReleaseDate: '2026-06-03' }, // 派生画面への表示項目パターン追加
  },
  {
    name: 'SIS機種レポート',
    href: '/report/sis',
    hasFavorite: true,
    decorationIcon: { type: 'update', prdReleaseDate: '2026-08-19' }, // 推移グラフ複数表示
  },
  {
    name: '台別データ一覧',
    href: '/report/dai',
    hasFavorite: true,
    decorationIcon: { type: 'update', prdReleaseDate: '2026-10-28' }, // 拾球率・役物率の追加
  },
  {
    name: 'モード別集計',
    href: '/report/mode',
    hasFavorite: true,
    decorationIcon: { type: 'update', prdReleaseDate: '2025-09-24' }, // 「勝率データ」追加
  },
  {
    name: '導入後推移',
    href: '/report/transitionAfterIntroduction',
    hasFavorite: true,
    decorationIcon: { type: 'update', prdReleaseDate: '2026-09-30' }, // 推移グラフ複数並列表示
  },
  {
    name: '期間推移',
    href: '/report/terminalTransition',
    hasFavorite: true,
    decorationIcon: { prdReleaseDate: '2026-04-01' }, // 店舗展開行のシェア項目の修正
  },
  {
    name: '機種別推移',
    href: '/report/modelTransition',
    hasFavorite: true,
    decorationIcon: { type: 'update', prdReleaseDate: '2026-09-16' }, // SISタイプ・機種タグ別表示
  },
];

/**
 * お気に入り機能がある画面名の順序
 */
export const favoritePageNameOrder: string[] = navigationItems
  .filter((item) => item.hasFavorite)
  .map((item) => item.name);
